import * as React from "react";
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { AutoCompleteInput, Button, Checkbox, Input, Label, ToggleFilter } from "uxp/components";
import { CustomColorPicker, Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle, RemoveButton } from "../../ui-props/common";
import {  DataSourcePropertyEditor } from "../../ui-props/DataSourceProperty";
import { SortableList } from "../sortableList/SortableList";
import { parseValue } from "../../../../util";
import { executeAndBind, findAvailableFields, IDataSource, IDataSourceBinding } from "../../data-source-picker/datasource";
import jp from 'jsonpath'
interface IToggleFieldProperty extends IBaseInputFieldProperty {
	useDataSource?: boolean,
	options?: Array<{ label: string, value: string }>
	binding: IDataSourceBinding;
	labelField: string;
	valueField: string;
	backgroundColor?: string,
	textColor?: string,
	disableShadow?: boolean,
	sBackground?: string,
	sTextColor?: string,
	useLabelAsValue?: boolean,
}

export const Field: React.FunctionComponent<IUIFieldProps<IToggleFieldProperty>> = (props) => {
	let { value, onChange, binding, labelField, valueField, useDataSource, backgroundColor, textColor, disableShadow, sBackground, sTextColor } = props?.fieldProps || {};
	
	const datasources: IDataSource[] = props.uiProps?.datasources || [];

	const [options, setOptions] = React.useState<Array<{ label: string, value: string }>>([]);
	const defaultOptions = [
		{ label: 'Option 01', value: 'val1' },
		{ label: 'Option 02', value: 'val2' },
	]

	React.useEffect(() => {
		console.log('use data source ', useDataSource,);

		if (props.mode != 'preview' && props.mode != 'thumbnail' && binding) {
			if (useDataSource) {
				executeAndBind(props.fieldProps.uxpContext, binding, datasources, {})
					.then((opts: any[]) => {
						const updated = opts.map((op: any) => {
							return { label: op[labelField], value: op[valueField] }
						})
						setOptions(updated);
					})
					.catch(console.error);
			}
			else { setOptions(props.fieldProps.options) }
		}
		else {
			if (useDataSource) {
				setOptions(defaultOptions)
			}
			else {
				setOptions(props.fieldProps.options || defaultOptions)
			}

		}
	}, [props.mode, props.fieldProps.options]);

	if (!value) value = 'val1'	

	return (
		<div className={`ui-field ${props.mode}`}>
			<ToggleFilter
				selectedBackgroundColor={ parseValue(sBackground, props.contextData) }
				selectedTextColor={ parseValue(sTextColor, props.contextData) }
				disableShadow={disableShadow}
				backgroundColor={ parseValue(backgroundColor, props.contextData) }
				textColor={ parseValue(textColor, props.contextData) }
				className="wg-toogle-filter"
				value={value}
				onChange={onChange}
				options={options}
			/>
		</div>
	)
}



export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IToggleFieldProperty>> = (props) => {

	let datasources: IDataSource[] = props.parentUIProps?.datasources || [];
	let pv = findAvailableFields(props.uiProps.binding, datasources);

	let _props = props.uiProps;

	const [changeOrder, setChangeOrder] = React.useState(false);

	const boxStyles = { 
		width: '100%', 
		height: '35px', 
		color: "white", 
		display: 'grid', 
		placeItems: 'center', 
		borderRadius: '5px', 
		marginBottom: '5px',
		background: '#424242', 
	};

	return <PropertyContainer>
		<PropertyGroup>
			{/* <PropertyGroupTitle>Toggle Input</PropertyGroupTitle> */}

			<Property>
				<PropertyTitle>Value</PropertyTitle>
				<Input
					value={_props.value || ''}
					onChange={s => props.onChange(Object.assign({}, _props, { value: s }))}
					className="widget-designer-input"
				/>
			</Property>

		</PropertyGroup>

		<PropertyGroup>
			<PropertyGroupTitle>Selected options</PropertyGroupTitle>
			<Property>
				<PropertyTitle>Disable Shadow</PropertyTitle>
				<Property>
					<Checkbox
						checked={_props?.disableShadow}
						onChange={s => props.onChange(Object.assign({}, _props, { disableShadow : s }))}
						label="Remove shadow"
						className="widget-designer-input"
					/>
				</Property>
				</Property>
			<Property>
				<PropertyTitle>Background</PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
						color={ _props?.sBackground || 'white'}
						onChange={s => 
							s === props?.uiProps?.sBackground ?
							props.onChange(Object.assign({}, _props, { sBackground : 'white' })) :
							props.onChange(Object.assign({}, _props, { sBackground: s }))
						}
					/>
			</Property>
			<Property>
				<PropertyTitle>Text</PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
						color={ _props?.sTextColor || 'white'}
						onChange={s => 
							s === props?.uiProps?.sTextColor ?
							props.onChange(Object.assign({}, _props, { sTextColor: '#424242' })) :
							props.onChange(Object.assign({}, _props, { sTextColor: s }))
						}
					/>
			</Property>
		</PropertyGroup>

		<PropertyGroup>
			<PropertyGroupTitle>Unselected options</PropertyGroupTitle>
			<Property>
				<PropertyTitle>Background</PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
						color={ _props?.backgroundColor || 'white'}
						onChange={s => 
							s === props?.uiProps?.backgroundColor ?
							props.onChange(Object.assign({}, _props, { backgroundColor: 'white' })) :
							props.onChange(Object.assign({}, _props, { backgroundColor: s }))
						}
					/>
			</Property>
			<Property>
				<PropertyTitle>Text</PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
						color={ _props?.textColor || 'white'}
						onChange={s => 
							s === props?.uiProps?.textColor ?
							props.onChange(Object.assign({}, _props, { textColor: '#424242' })) :
							props.onChange(Object.assign({}, _props, { textColor: s }))
						}
					/>
			</Property>
		</PropertyGroup>

		<PropertyGroup>
			<PropertyGroupTitle>Options</PropertyGroupTitle>

			<Property>
				<Checkbox
					checked={_props.useDataSource}
					onChange={s => props.onChange(Object.assign({}, _props, { useDataSource: s }))}
					label="Get options form a data source"
					className="widget-designer-input"
				/>
			</Property>
			{_props.useDataSource ? <>
				<Property>
					<DataSourcePropertyEditor
						binding={_props.binding}
						context={props.uxpContext}
						onChange={(binding) => props.onChange(Object.assign({}, _props, { binding }))}
						onChangeAny={(p, v) => {
							props.onChangeAny(p, v);
						}}
						sources={datasources}
						target={'dictionary-array'}
						title='Data Source'
						contextData={props.contextData}
						className='uxp-designer-data-source-selector'
						designer={props.designer}
				
					/>
				</Property>

				<Property>
					<PropertyTitle>Label Field</PropertyTitle>
					<AutoCompleteInput
						options={pv}
						value={_props.labelField || ''}
						onChange={s => props.onChange(Object.assign({}, _props, { labelField: s }))}
					/>
				</Property>

				<Property>
					<PropertyTitle>Value Field</PropertyTitle>
					<AutoCompleteInput
						options={pv}
						value={_props.valueField || ''}
						onChange={s => props.onChange(Object.assign({}, _props, { valueField: s }))}
					/>
				</Property>
			</>
				:
				<>
						<Property>

							{_props?.options?.length &&
							<>
							<div className="wd-ui-property-group-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
								Options
								{props?.uiProps?.options.length >= 2 && 
										<Button title={!changeOrder ? 'Change Order' : 'Done' } onClick={() => setChangeOrder(pre => !pre)} styles={{ margin: '0'}}/>
								}
							</div>
							{props?.uiProps?.options.length >= 2 && <span>Drag and drop to change the order</span>}
							</>
							
							}
							{!_props?.options?.length && <Label>No options were added</Label>}
							<div>
								<Button 
									styles={{margin: '5px 0'}}
									className="new-option"
									title="Add New Option" 
									icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
									iconPosition="right" 
									onClick={() => {
										let options = _props?.options || []
										options.unshift({ label: '', value: '' })
										props.onChange(Object.assign({}, _props, { options }))
									}}
								/>

								<SortableList 
									items={props?.uiProps?.options}
									onSort={(list: any) => props.onChange(Object.assign({}, _props, { options: list }))}
									renderItem={(s:any, i: any)=>
										<>
											{changeOrder &&
												<div style={boxStyles}>
													{s.label}
												</div>
											}
										</>
									}
								/>
									

								{!changeOrder && 
								_props?.options?.map((s, i) => {
									return(
											<div className="ui-field-config-item-row" style={{paddingBottom: '5px'}}>
												<div className="column" style={{ width: !_props.useLabelAsValue ? '45%' : '90%' }}>
													<Input
														placeholder="Label"
														value={s?.label || ''}
														onChange={s => {
															if (_props.useLabelAsValue) {
																jp.apply(_props, `$.options[${i}].value`, () => (s))
															}

															jp.apply(_props, `$.options[${i}].label`, () => (s))
															props.onChange(_props)
														}}
													/>
												</div>
												{
													!_props.useLabelAsValue && <div className="column" style={{ width: '45%' }}>

														<Input
															placeholder="Value"
															value={s?.value || ''}
															onChange={s => {
																jp.apply(_props, `$.options[${i}].value`, () => (s))
																props.onChange(_props)
															}}
														/>
													</div>
												}

												<div className="column  action-column">
													<RemoveButton onClick={() => {
														let options = _props?.options || []
														options.splice(i, 1)

														jp.apply(_props, `$.options`, () => (options))
														props.onChange(_props)
													}} />
												</div>
												
											</div>
									)
								})}
								

								<div style={{marginTop: '15px'}}>
									<Checkbox
										checked={_props.useLabelAsValue}
										onChange={s => {
											if (s) {
												let options = _props?.options?.map((v) => ({ ...v, value: v?.label }))
												jp.apply(_props, `$.options`, () => (options))
											}

											props.onChange(Object.assign({}, _props, { useLabelAsValue: s }))
										}}
										label="Use label as value"
										className="widget-designer-input"
									/>
								</div>
								
							</div>

						</Property>

					</>
			}

		</PropertyGroup>
	</PropertyContainer>;
}

registerUIField({
	id: 'toggle',
	category: 'inputs',
	description: 'Toggle Input',
	field: Field,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		binding: null,
		labelField: 'label',
		valueField: 'value',
		useDataSource: false,
		useLabelAsValue: true,
		disableShadow: false
	},
	type: 'text',

});
